import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AccountPackageService } from '../service/account-package.service';
import { UtilService } from '../service/util.service';
import { ApiService } from '../service/api.service';
import { AuthenticationService } from '../service/authentication.service';
import { Constants } from '../constants/constants';
import { NavigationExtras, Router } from '@angular/router';
import { ToastService } from '../service/toast.service';
import { SearchResultsComponent } from '../search-results/search-results.component';
import { SearchDataService } from '../service/search-data.service';
import { EnvService } from '../service/env.service';

@Component({
  selector: 'app-account-management',
  templateUrl: './account-management.component.html',
  styleUrls: ['./account-management.component.scss']
})
export class AccountManagementComponent implements OnInit {

  readonly CHOOSE_FILE: string = "Select File";

  servicePackages: any = {};
  locations: Array<any> = new Array();
  activePackages: Array<any> = new Array();
  pkgList: Array<any> = new Array();
  connectedVehicles: number = 0;
  accountCategory: string;
  importFile: File = null;
  accountDetail: any;

  isViewScreen: boolean = false;
  selectedPkgForView = null;

  private FLEET_MANAGEMENT_COMPANY: string = "FLEET_MANAGEMENT_COMPANY";

  //Search result storage variable
  @ViewChild('searchResult') searchResult:SearchResultsComponent;
  searchedLocationList: Array<any>;
  searchedServicePackageList: Array<any>;
  searchedVehicleList: Array<any>;
  selectedSearchItemForView: string;
  showSearchResult: boolean = false;

  importFileName: string = this.CHOOSE_FILE;
  @ViewChild('assignPkgToVehicleInput', { static: true }) assignPkgToVehicleInput: ElementRef;

  yyyymmddDate = null;
  csvSampleImportVehicleServicePackageMappingFileName = null;
  csvSampleImportVehicleServicePackageMappingFileUrl = Constants.IMPORT_VEHICLE_PACKAGE_MAPPING_SAMPLE_CSV_URL;
  mimeType = "csv";

  constructor(private accountServicePackage: AccountPackageService, public apiService: ApiService, public authService: AuthenticationService, public utilService: UtilService, private router: Router, private toast: ToastService, private searchService: SearchDataService, private env: EnvService) { }

  ngOnInit() {
    this.yyyymmddDate = this.utilService.getYYYYMMDDhhmm(new Date());
    this.csvSampleImportVehicleServicePackageMappingFileName = "NCC_VehicleServicePackageMapping_" + this.yyyymmddDate + ".csv";

    this.accountCategory = this.apiService.accountDetail.category;
    this.servicePackages = this.accountServicePackage.getServicePackage();
    this.getAccountDetail();
    this.searchService.searchedData.subscribe(data => {
      this.processSearchResult();
    });
  }

  private processSearchResult() {
    this.searchedVehicleList = this.searchService.getSearchedDataForType(Constants.VEHICLES);
    this.searchedLocationList = this.searchService.getSearchedDataForType(Constants.LOCATIONS);
    this.searchedServicePackageList = this.searchService.getSearchedDataForType(Constants.SERVICE_PACKAGE);
    this.selectedSearchItemForView = null;
    if ((this.searchedVehicleList && this.searchedVehicleList.length > 0) ||
      (this.searchedLocationList && this.searchedLocationList.length > 0) ||
      (this.searchedServicePackageList && this.searchedServicePackageList.length > 0)) {
      this.isViewScreen = false;
      this.showSearchResult = true;
    } else {
      this.showSearchResult = false;
    }
  }

  ngOnDestroy() {
    this.searchService.resetPreviousSearchResult();
  }

  onSearchItemDetail(searchItem: string) {
    this.selectedSearchItemForView = searchItem;
  }

  onNavSearchClick() {
    this.searchResult.onNavSearchClick();
  }

  getActivePackages() {
    this.pkgList.forEach(element => {
      if (element.inUse) {
        this.activePackages.push(element);
      }
    });
  }

  onFileSelected(files: FileList, type: string) {
    this.importFile = null;
    if (this.isFileSelected(files)) {
      let file: File = files.item(0);
      this.updateFileName(file);
      if (this.isCsvFile(file.name) && this.isValidFileName(file.name, type)) {
        this.importFile = file;
      } else {
        this.resetUpdatePackageImport();
      }
    } else {
      this.resetUpdatePackageImport();
    }
  }

  uploadFile() { 
    let formData: FormData = new FormData();
    formData.append('file', this.importFile, this.importFile.name);
    this.uploadCsvFile(formData);
  }

  isFileSelected(files: FileList) {
    if (files && files.length > 0)
      return true;
    return false;
  }

  isCsvFile(name: string) {
    let splitStr = name.split('.');
    let extension = splitStr[splitStr.length - 1];
    if (extension.toLowerCase() != 'csv') {
      this.toast.showError("Please select .csv file only");
      return false;
    }
    return true;
  }

 isValidFileName(name: string, type: string) {
    let splitStr = name.split('_');
    if(splitStr.length < 3) {
      this.toast.showError("Invalid file name format. Expected file name format: NCC_" + type + "_05132019101630.csv");
      return false;
    }
    let importType = splitStr[1];
    // let accountId = splitStr[2];
    if(importType != type) {
      this.toast.showError("Invalid file name format. Expected file name format: NCC_" + type + "_05132019101630.csv");
      return false;
    }
    // if(accountId != this.accountDetail.id) {
    //   this.toast.showError("The accountId in the filename doesn't match the selected fleet's accountId.");
    //   return false;
    // }
    return true;
  }

  uploadCsvFile(formData: FormData) {
    this.utilService.showSpinner();
    this.apiService.uploadCsv(formData).then((data) => {
      this.utilService.hideSpinner();
      console.log("file upload response :: ", data);
      this.toast.showSuccess(data.message);
      this.importFile = null;
      document.getElementById("closeImportupdatePackage").click();
    }).catch((error) => {
      console.log("err : ", error);
      this.importFile = null;
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.uploadCsvFile(formData);
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  getAccountDetail() {
    this.utilService.showSpinner();
    this.apiService.getAccountPackageLocationDetail().then((data) => {
      this.utilService.hideSpinner();
      this.accountDetail = data;
      this.getPackageList();
      // this.pkgList = data.servicePackages;
      // this.pkgList = this.accountServicePackage.setPackageRatePlan(data.servicePackages);
      if(this.accountCategory == this.FLEET_MANAGEMENT_COMPANY) {
        this.locations = [];
        data.locations.forEach(element => {
          if(element.type == "FACILITY")
          this.locations.push(element);
        });
      } else {
        this.locations = data.locations;
      }
      this.connectedVehicles = data.vehicles;
      this.utilService.selectedRentalFleetAccount = this.accountDetail;
      console.log("Account detail from API::", this.accountDetail);
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.getAccountDetail();
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  getPackageList() {
    this.utilService.showSpinner();
    this.apiService.getAccountServicePackageList().then((data) => {
      this.utilService.hideSpinner();
      this.pkgList = this.accountServicePackage.setPackageRatePlan(data);
      console.log("service package from API::", this.pkgList);
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.getPackageList();
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  goToServicePackages() {
    let navigationExtras: NavigationExtras = {
      queryParams: {
        "connectedVehicles": this.connectedVehicles
      }
    };

    this.router.navigate(['/service-packages'], navigationExtras);
  }

  packageClickedForView(pkg) {
    this.isViewScreen = true;
    this.selectedPkgForView = JSON.parse(JSON.stringify(pkg));
  }

  closeOfViewClicked(data) {
    this.isViewScreen = false;
  }

  updateFileName(file: File) {
    var fileName = file.name;
    this.importFileName = fileName;
  }

  resetUpdatePackageImport() {
    this.assignPkgToVehicleInput.nativeElement.value = null;
    this.importFileName = this.CHOOSE_FILE;
    this.importFile = null;
  }
  
  doesAccountSupportsDongle() {
    if (this.authService.accountData != null)
      return this.authService.isShowDeveloperAccess(this.authService.accountData.type);

    return false;
  }

  downloadSampleCsv(filename, url) {
    console.log("attachment mime type::", this.mimeType);
    this.utilService.showSpinner();
    var attachmentUrl = this.env.BASE_URL + url;

    this.apiService.downloadPdf(attachmentUrl).then((data) => {
      this.prepareToDownload(data, this.mimeType, filename);
      this.utilService.hideSpinner();
    }).catch((error) => {
      console.log("err : ", error);
      if (error && error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.downloadSampleCsv(filename, url);
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  prepareToDownload(data, mimeType, filename: string) {
    var blob = new Blob([data], { type: mimeType });

    var downloadURL = window.URL.createObjectURL(blob);
    var link = document.createElement('a');
    link.href = downloadURL;
    link.download = filename;
    link.click();
  }
}
